import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const whatsappUrl =
    'https://wa.me/558393917008?text=Fala%20Lucas%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20mentoria%20OFM%20ELITE%21'

  return (
    <nav
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-colors duration-300 h-[80px] flex items-center',
        isScrolled
          ? 'bg-black/95 backdrop-blur-md border-b border-white/10'
          : 'bg-transparent',
      )}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Logo */}
        <Link
          to="/"
          className="text-2xl font-black font-heading tracking-tighter text-white"
        >
          OFM <span className="text-primary">ELITE</span>
        </Link>

        {/* Desktop CTA */}
        <div className="hidden md:block">
          <Button
            asChild
            className="bg-primary hover:bg-primary/90 text-white font-bold px-8 py-6 rounded-lg text-lg shadow-glow-orange transition-all hover:scale-105 uppercase tracking-wide"
          >
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              Quero Minha Vaga
            </a>
          </Button>
        </div>

        {/* Mobile Menu */}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="text-white hover:bg-white/10"
              >
                <Menu className="h-8 w-8" />
              </Button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="bg-black border-l border-white/10 w-full flex flex-col items-center justify-center p-0"
            >
              <div className="flex flex-col items-center gap-8">
                <div className="text-4xl font-black font-heading tracking-tighter text-white mb-8">
                  OFM <span className="text-primary">ELITE</span>
                </div>
                <SheetClose asChild>
                  <Button
                    asChild
                    className="bg-primary hover:bg-primary/90 text-white font-bold text-xl px-12 py-8 h-auto rounded-lg shadow-glow-orange w-full max-w-xs uppercase"
                  >
                    <a
                      href={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Quero Minha Vaga
                    </a>
                  </Button>
                </SheetClose>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  )
}
